import { motion } from "framer-motion";

// Editorial chapter header block. Left column shows numbered manifesto label.
export default function ChapterHeader({ n, title, kicker, children, titleClassName = "" }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10 mb-14 md:mb-24">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-15%" }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="md:col-span-3"
      >
        <div className="flex md:block items-baseline gap-3">
          <span className="font-mono text-xs md:text-sm text-accent tracking-[0.2em] uppercase">
            {n}.
          </span>
          <div className="mt-0 md:mt-3 font-mono text-[11px] uppercase tracking-[0.25em] text-muted-foreground">
            {kicker || "Chapter"}
          </div>
        </div>
        <h2 className={`mt-2 md:mt-6 font-heading font-black text-3xl md:text-5xl tracking-tighter leading-[0.95] uppercase ${titleClassName}`}>
          {title}
        </h2>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-10%" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.08 }}
        className="md:col-span-9"
      >
        {children}
      </motion.div>
    </div>
  );
}
